import React, { useEffect } from "react";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { NavLink, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import {
  saveActiveSidebarTab,
  saveSideBarScrollPosition,
  updateDateFilter,
  updateFiltersStates,
} from "../../store/actions/UserActions";
import DashboardIcon from "../Icons/Sidebar/DashboardIcon";
import SitesIcon from "../Icons/Sidebar/SitesIcon";
import AttendanceIcon from "../Icons/Sidebar/AttendanceIcon";
import LeaveIcon from "../Icons/Sidebar/LeaveIcon";
import AttRegulerizationIcon from "../Icons/Sidebar/AttRegulerizationIcon";
import HolidaysIcon from "../Icons/Sidebar/HolidaysIcon";
import ODAplicationIcon from "../Icons/Sidebar/ODAplicationIcon";
import PaySlipIcon from "../Icons/Sidebar/PaySlipIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  checkUserAccess,
  getCurrentFinancialYear,
} from "../../utility/CommonFunctions";
import NotificationIcon from "../Icons/Sidebar/NotificationIcon";
import LedgerIcon from "../Icons/Sidebar/LedgerIcon";
import VoucherIcon from "../Icons/Sidebar/VoucherIcon";
import moment from "moment";
import ChevronArrow from "../Icons/Sidebar/ChevronArrow";
import CompanyIcon from "../Icons/Sidebar/CompanyIcon";
import ItemMasterIcon from "../Icons/Sidebar/ItemMasterIcon";
import BudgetIcon from "../Icons/Sidebar/BudgetIcon";
import { OfficeTaskIcon } from "../Icons/Sidebar/OfficeTaskIcon";
import { SiteTaskIcon } from "../Icons/Sidebar/SiteTaskIcon";
import { HowToUseIcon } from "../Icons/Sidebar/HowToUseIcon";

export default function UserSidebar() {
  const dispatch = useDispatch();
  const location = useLocation();

  const nonActiveNumber = -1;

  const userDetails = useSelector((state) => state.root.userDetails);
  const activeSidebarTab = useSelector((state) => state.root.activeSidebarTab);
  const scrollPosition = useSelector((state) => state.root.scrollPosition);

  const Site1 = [
    {
      label: "Company",
      permissionKey: "show",
      to: RoutesLink.company,
      relatedRoutes: [
        RoutesLink.company,
        RoutesLink?.add_company,
        `${RoutesLink?.company_detail}/:id`,
      ],
      icon: <CompanyIcon />,
    },
    {
      label: "Customers",
      permissionKey: "show",
      to: RoutesLink.customers,
      relatedRoutes: [
        RoutesLink.customers,
        RoutesLink?.add_customer,
        `${RoutesLink?.customer_detail}/:id`,
      ],
      icon: <ItemMasterIcon />,
    },
    {
      label: "O&M",
      permissionKey: "show",
      to: RoutesLink.sites_OandM,
      relatedRoutes: [RoutesLink.sites_OandM],
      icon: "",
      subMenu: [
        {
          label: "Sites",
          permissionKey: "show",
          to: RoutesLink.sites_OandM,
          relatedRoutes: [
            RoutesLink.sites_OandM,
            RoutesLink?.add_site,
            `${RoutesLink?.site_detail}/:id`,
          ],
        },
        {
          label: "Site Salary Head",
          permissionKey: "show",
          to: RoutesLink.site_salary_head,
          state: { data: { type: "O%26M" } },
          relatedRoutes: [
            RoutesLink.site_salary_head,
            RoutesLink?.add_salary_head,
          ],
        },
      ],
    },
    {
      label: "Project",
      permissionKey: "show",
      to: RoutesLink.sites_project,
      relatedRoutes: [RoutesLink.sites_project],
      icon: "",
      subMenu: [
        {
          label: "Sites",
          permissionKey: "show",
          to: RoutesLink.sites_project,
          relatedRoutes: [
            RoutesLink.sites_project,
            RoutesLink?.add_site,
            `${RoutesLink?.site_detail}/:id`,
          ],
        },
        {
          label: "Site Salary Head",
          permissionKey: "show",
          to: RoutesLink.site_salary_head,
          state: { data: { type: "project" } },
          relatedRoutes: [
            RoutesLink.site_salary_head,
            RoutesLink?.add_salary_head,
          ],
        },
      ],
    },
    {
      label: "Budget Request",
      permissionKey: "br",
      to: RoutesLink.budget_requests,
      relatedRoutes: [
        RoutesLink.budget_requests,
        `${RoutesLink?.budget_logs}/:id`,
      ],
      icon: <BudgetIcon />,
    },
  ];

  const Site2 = [
    ...(userDetails?.assignedSiteType === "O&M" ||
      userDetails?.assignedSiteType === "both" ||
      userDetails?.assignedSiteType == null
      ? [
        {
          label: "O&M",
          permissionKey: "show",
          to: RoutesLink.sites_OandM,
          relatedRoutes: [RoutesLink.sites_OandM],
          icon: "",
          subMenu: [
            {
              label: "Sites",
              permissionKey: "show",
              to: RoutesLink.sites_OandM,
              relatedRoutes: [
                RoutesLink.sites_OandM,
                RoutesLink?.add_site,
                `${RoutesLink?.site_detail}/:id`,
              ],
            },
            ...(userDetails?.department?.name === "HRM"
              ? [
                {
                  label: "Site Salary Head",
                  permissionKey: "br",
                  to: RoutesLink.site_salary_head,
                  state: { data: { type: "O%26M" } },
                  relatedRoutes: [
                    RoutesLink.site_salary_head,
                    RoutesLink?.add_site_salary_head,
                  ],
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    ...(userDetails?.assignedSiteType === "project" ||
      userDetails?.assignedSiteType === "both" ||
      userDetails?.assignedSiteType == null
      ? [
        {
          label: "Project",
          permissionKey: "show",
          to: RoutesLink.sites_project,
          relatedRoutes: [RoutesLink.sites_project],
          icon: "",
          subMenu: [
            {
              label: "Sites",
              permissionKey: "show",
              to: RoutesLink.sites_project,
              relatedRoutes: [
                RoutesLink.sites_project,
                RoutesLink?.add_site,
                `${RoutesLink?.site_detail}/:id`,
              ],
            },
            ...(userDetails?.department?.name === "HRM"
              ? [
                {
                  label: "Site Salary Head",
                  permissionKey: "show",
                  to: RoutesLink.site_salary_head,
                  state: { data: { type: "project" } },
                  relatedRoutes: [
                    RoutesLink.site_salary_head,
                    RoutesLink?.add_salary_head,
                  ],
                },
              ]
              : []),
          ],
        },
      ]
      : []),
    {
      label: "Budget Request",
      permissionKey: "br",
      to: RoutesLink.budget_requests,
      relatedRoutes: [
        RoutesLink.budget_requests,
        `${RoutesLink?.budget_logs}/:id`,
      ],
      icon: <BudgetIcon />,
    },
  ];

  const groupedMenu = {
    Site: userDetails?.department?.name === "Management" ? Site1 : Site2,
    HRM: [
      {
        label: "Attendance",
        permissionKey: "attendance",
        to: RoutesLink.attendance,
        relatedRoutes: [RoutesLink.attendance_user],
        icon: <AttendanceIcon />,
        subMenu: [
          {
            label: "My Attendance",
            permissionKey: "attendance",
            to: RoutesLink.attendance_user,
            relatedRoutes: [],
          },
          ...(userDetails?.designation?.canAccessTeam
            ? [
              {
                label: "Daily Team Att.",
                permissionKey: "attendance",
                to: RoutesLink.team_attendance,
                relatedRoutes: [],
              },
              {
                label: "Monthly Team Att.",
                permissionKey: "attendance",
                to: RoutesLink.attendance_summary,
                relatedRoutes: [
                  RoutesLink.attendance_summary_details + `/:id`,
                ],
              },
              {
                label: "Manage Bulk Att.",
                permissionKey: "attendance",
                to: RoutesLink.manage_bulk_attendance,
                relatedRoutes: [
                  // RoutesLink.attendance_summary_details + `/:id`,
                ],
              },
            ]
            : []),
        ],
      },
      {
        label: "Extra Work",
        permissionKey: "ew",
        to: RoutesLink.extra_work_user,
        relatedRoutes: [RoutesLink.extra_work_user],
        icon: <AttendanceIcon />,
        subMenu: [
          {
            label: "My Extra Work",
            permissionKey: "ew",
            to: RoutesLink.extra_work_user,
            relatedRoutes: [RoutesLink.extra_work_user],
          },
          ...(userDetails?.designation?.canAccessTeam
            ? [
              {
                label: "Team Extra Work",
                permissionKey: "ew",
                to: RoutesLink.extra_work_team,
                relatedRoutes: [RoutesLink.extra_work_team],
              },
            ]
            : []),
        ],
      },
      {
        label: "Leave",
        permissionKey: "leave",
        to: RoutesLink.my_leave,
        relatedRoutes: [RoutesLink.my_leave],
        icon: <LeaveIcon />,
        subMenu: [
          {
            label: "My Leave",
            permissionKey: "leave",
            to: RoutesLink.my_leave,
            relatedRoutes: [RoutesLink.my_leave],
          },
          ...(userDetails?.designation?.canAccessTeam
            ? [
              {
                label: "Team Leave",
                permissionKey: "leave",
                to: RoutesLink.team_leave,
                relatedRoutes: [RoutesLink.team_leave],
              },
            ]
            : []),
        ],
      },
      {
        label: "Att. Regularization",
        permissionKey: "ar",
        to: RoutesLink.my_Ar,
        relatedRoutes: [RoutesLink.my_Ar],
        icon: <AttRegulerizationIcon />,
        subMenu: [
          {
            label: "My A.R.",
            permissionKey: "ar",
            to: RoutesLink.my_Ar,
            relatedRoutes: [RoutesLink.my_Ar, RoutesLink?.ar_request_detail],
          },
          ...(userDetails?.designation?.canAccessTeam
            ? [
              {
                label: "Team A.R.",
                permissionKey: "ar",
                to: RoutesLink.team_Ar,
                relatedRoutes: [
                  RoutesLink.team_Ar,
                  RoutesLink?.ar_request_detail,
                ],
              },
            ]
            : []),
        ],
      },
      {
        label: "OD Application",
        permissionKey: "od",
        to: RoutesLink.my_od,
        relatedRoutes: [RoutesLink.my_od],
        icon: <ODAplicationIcon />,
        subMenu: [
          {
            label: "My O.D.",
            permissionKey: "od",
            to: RoutesLink.my_od,
            relatedRoutes: [RoutesLink.my_od, RoutesLink?.add_Od_request],
          },
          ...(userDetails?.designation?.canAccessTeam
            ? [
              {
                label: "Team O.D.",
                permissionKey: "od",
                to: RoutesLink.team_od,
                relatedRoutes: [
                  RoutesLink.team_od,
                  RoutesLink?.od_request_detail,
                ],
              },
            ]
            : []),
        ],
      },
      {
        label: "WFH Application",
        permissionKey: "wfh",
        to: RoutesLink.my_wfh,
        relatedRoutes: [RoutesLink.my_wfh],
        icon: <LeaveIcon />,
        subMenu: [
          {
            label: "My WFH",
            permissionKey: "wfh",
            to: RoutesLink.my_wfh,
            relatedRoutes: [RoutesLink.my_wfh, RoutesLink?.add_wfh_request],
          },
          ...(userDetails?.designation?.canAccessTeam ||
            userDetails?.department?.name === "Management" ||
            userDetails?.department?.name === "HRM"
            ? [
              {
                label: "Team WFH",
                permissionKey: "wfh",
                to: RoutesLink.team_wfh,
                relatedRoutes: [
                  RoutesLink.team_wfh,
                  RoutesLink?.wfh_request_detail,
                ],
              },
            ]
            : []),
        ],
      },
      {
        label: "Reimbursement",
        permissionKey: "rf",
        to: RoutesLink.my_Reimbursement_Form,
        relatedRoutes: [RoutesLink.my_Reimbursement_Form],
        icon: <PaySlipIcon />,
        subMenu: [
          {
            label: "My Reimb.",
            permissionKey: "rf",
            to: RoutesLink.my_Reimbursement_Form,
            relatedRoutes: [
              RoutesLink.create_Reimbursement_Form,
              RoutesLink.reimbursement_details + "/:id",
              `${RoutesLink?.payment_tickets_details}/reimbursement/:id`,
            ],
          },
          ...((userDetails?.designation?.canAccessTeam || userDetails?.department?.name === "Account")
            ? [
              {
                label: "Team Reimb.",
                permissionKey: "rf",
                to: RoutesLink.team_Reimbursement_Form,
                relatedRoutes: [
                  RoutesLink.team_Reimbursement_Form,
                  `${RoutesLink.team_Reimbursement_Form}/:id`,
                  `${RoutesLink?.payment_tickets_details}/reimbursement/:id`,
                ],
              },
            ]
            : []),
        ],
      },
      {
        label: "Payslip",
        permissionKey: "paySlip",
        to: RoutesLink.payslip,
        relatedRoutes: [RoutesLink.payslip],
        icon: <PaySlipIcon />,
        subMenu: [
          {
            label: "My Payslip",
            permissionKey: "paySlip",
            to: RoutesLink.my_payslip,
            relatedRoutes: [RoutesLink.my_payslip],
          },
          ...(userDetails?.department?.name === "HRM" ||
            userDetails?.department?.name === "Management"
            ? [
              {
                label: "Team Payslip",
                permissionKey: "paySlip",
                to: RoutesLink.payslip,
                relatedRoutes: [
                  RoutesLink.payslip,
                  `${RoutesLink?.payslip_site_wise}/:id`,
                ],
              },
            ]
            : []),
        ],
      },
      ...(!checkUserAccess(userDetails).isUserAccess
        ? [
          {
            label: "Holidays",
            permissionKey: "attendance",
            to: RoutesLink.holiday,
            relatedRoutes: [RoutesLink.holiday],
            icon: <HolidaysIcon />,
          },
        ]
        : []),
      {
        label: "HRM Settings",
        permissionKey: "hs",
        to: RoutesLink.shifts,
        relatedRoutes: [RoutesLink.shifts],
        icon: <AttendanceIcon />,
        subMenu: [
          {
            label: "Shift & Time Config",
            permissionKey: "hs",
            to: RoutesLink.shifts,
            relatedRoutes: [RoutesLink.shifts, RoutesLink?.add_Shift],
          },
          {
            label: "Employee Onboard",
            permissionKey: "hs",
            to: RoutesLink.employee_onboard,
            relatedRoutes: [
              RoutesLink.employee_onboard,
              RoutesLink?.add_employee_onboard,
              `${RoutesLink?.employee_detail}/:id`,
            ],
          },
          {
            label: "Salary Head",
            permissionKey: "hs",
            to: RoutesLink.salary_head,
            relatedRoutes: [RoutesLink.salary_head, RoutesLink.add_salary_head],
          },
          {
            label: "Holiday Setting",
            permissionKey: "hs",
            to: RoutesLink.holiday,
            relatedRoutes: [RoutesLink.holiday],
          },
          {
            label: "Office Location",
            permissionKey: "hs",
            to: RoutesLink.office_location,
            relatedRoutes: [RoutesLink.office_location, RoutesLink.add_office],
          },
          {
            label: "Leave Setting",
            permissionKey: "hs",
            to: RoutesLink.leave_setting,
            relatedRoutes: [
              RoutesLink.leave_setting,
              RoutesLink.add_leave_setting,
            ],
          },
          {
            label: "Site Salary Config",
            permissionKey: "hs",
            to: RoutesLink.site_salary_config,
            relatedRoutes: [RoutesLink.site_salary_config],
          },
          {
            label: "Office Salary Config",
            permissionKey: "hs",
            to: RoutesLink.office_salary_head,
            relatedRoutes: [RoutesLink.office_salary_head, RoutesLink.add_office_salary_head],
          },
          {
            label: "Transfer Requests",
            permissionKey: "hs",
            to: RoutesLink.transfer_requests,
            relatedRoutes: [RoutesLink.transfer_requests],
          },
        ],
      },
    ],
    Accounts: [
      {
        label: "Sales Order",
        permissionKey: "wo",
        to: RoutesLink.work_order,
        relatedRoutes: [
          RoutesLink.work_order,
          `${RoutesLink?.work_order_detail}/:id`,
          RoutesLink?.add_work_order,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Invoice",
        permissionKey: "inv",
        to: RoutesLink.invoice,
        relatedRoutes: [
          RoutesLink.invoice,
          `${RoutesLink?.invoice_detail}/:id`,
          RoutesLink?.create_invoice,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Debit Note",
        permissionKey: "dn",
        to: RoutesLink.debit_note,
        relatedRoutes: [RoutesLink.debit_note],
        icon: <LedgerIcon />,
      },
      {
        label: "Day Book",
        permissionKey: "cb",
        to: RoutesLink.day_book,
        relatedRoutes: [RoutesLink.day_book],
        icon: <LedgerIcon />,
      },
      {
        label: "Customer Ledger",
        permissionKey: "cl",
        to: RoutesLink.customer_ledger,
        relatedRoutes: [
          RoutesLink?.customer_ledger,
          `${RoutesLink?.customer_ledger_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Vendor Ledger",
        permissionKey: "vl",
        to: RoutesLink.vendor_ledger,
        relatedRoutes: [
          RoutesLink.vendor_ledger,
          `${RoutesLink.vendor_ledger_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "TDS Ledger",
        permissionKey: "tl",
        to: RoutesLink.tds_ledger,
        relatedRoutes: [RoutesLink.tds_ledger, `${RoutesLink?.tds_detail}/:id`],
        icon: <LedgerIcon />,
      },

      {
        label: "Payment Advisory",
        permissionKey: "pa",
        to: RoutesLink.payment_advisory,
        relatedRoutes: [
          RoutesLink.payment_advisory,
          `${RoutesLink.payment_advisory_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Payment Overview",
        permissionKey: "pto",
        to: RoutesLink.payment_overview,
        relatedRoutes: [RoutesLink.payment_overview],
        icon: <VoucherIcon />,
      },
    ],
    SCM: [
      {
        label: "Purchase Request",
        permissionKey: "pr",
        to: RoutesLink.purchase_request,
        relatedRoutes: [
          RoutesLink.purchase_request,
          `${RoutesLink?.purchase_request_detail}/:id`,
          RoutesLink?.create_purchase_request,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Purchase",
        permissionKey: "purchase",
        to: RoutesLink.purchase,
        relatedRoutes: [
          RoutesLink?.purchase,
          `${RoutesLink?.purchase_order_detail}/:id`,
          `${RoutesLink?.purchase_request_detail}/:id`,
          RoutesLink?.create_purchase,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Purchase Order",
        permissionKey: "po",
        to: RoutesLink.purchase_order,
        relatedRoutes: [
          RoutesLink?.purchase_order,
          `${RoutesLink?.purchase_order_detail}/:id`,
        ],
        icon: <LedgerIcon />,
      },
      {
        label: "Stock",
        permissionKey: "stock",
        to: RoutesLink.stock,
        relatedRoutes: [RoutesLink?.stock, `${RoutesLink?.stock_detail}/:id`],
        icon: <SitesIcon />,
      },
      {
        label: "Stock Out",
        permissionKey: "stockOut",
        to: RoutesLink.stock_out,
        relatedRoutes: [
          RoutesLink?.stock_out,
          `${RoutesLink?.stock_out_detail}/:id`,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Transfer Assets",
        permissionKey: "ta",
        to: RoutesLink.transfer_assets,
        relatedRoutes: [
          RoutesLink?.transfer_assets,
          RoutesLink?.create_transfer_asset,
          `${RoutesLink?.transfer_asset_detail}/:id`,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Good Received Notes",
        permissionKey: "grn",
        to: RoutesLink.grn,
        relatedRoutes: [
          RoutesLink?.grn,
          RoutesLink?.createGrn,
          `${RoutesLink?.grn_detail}/:id`,
        ],
        icon: <SitesIcon />,
      },
      {
        label: "Machinery",
        permissionKey: "show",
        to: RoutesLink.machinery,
        relatedRoutes: [
          RoutesLink.machinery,
          RoutesLink.add_machinery,
          `${RoutesLink.machinery_details}/:id`,
        ],
        icon: <SitesIcon />,
        subMenu: [
          {
            label: "Machinery List",
            permissionKey: "show",
            to: RoutesLink.machinery,
            relatedRoutes: [
              RoutesLink.machinery,
              `${RoutesLink.machinery_details}/:id`,
            ],
          },
          {
            label: "Add Machinery",
            permissionKey: "show",
            to: RoutesLink.add_machinery,
            relatedRoutes: [RoutesLink.add_machinery],
          },
        ],
      },
      {
        label: "SCM Settings",
        permissionKey: "ss",
        to: RoutesLink.shifts,
        relatedRoutes: [RoutesLink.shifts],
        icon: <AttendanceIcon />,
        subMenu: [
          {
            label: "Vendor List",
            permissionKey: "ss",
            to: RoutesLink.vendor_list,
            relatedRoutes: [
              RoutesLink.vendor_list,
              RoutesLink?.add_vendor,
              `${RoutesLink?.vendor_detail}/:id`,
            ],
          },
          {
            label: "Expense Head",
            permissionKey: "ss",
            to: RoutesLink?.expense_head,
            relatedRoutes: [RoutesLink?.expense_head],
          },
          {
            label: "Gen.Expense Head",
            permissionKey: "ss",
            to: RoutesLink.general_expense_head,
            relatedRoutes: [RoutesLink.general_expense_head],
          },
          {
            label: "Service Type",
            permissionKey: "ss",
            to: RoutesLink.service_type,
            relatedRoutes: [RoutesLink.service_type],
          },
          {
            label: "Item Master",
            permissionKey: "ss",
            to: RoutesLink.item_master,
            relatedRoutes: [RoutesLink?.item_master],
          },
        ],
      },
    ],
    default: [
      {
        label: "Payment Tickets",
        permissionKey: "pt",
        to: RoutesLink.payment_ticket_against_po,
        relatedRoutes: [
          RoutesLink.payment_ticket_against_po,
          RoutesLink.payment_ticket_general,
          RoutesLink.payment_ticket_reimbursement,
        ],
        icon: "",
        isShowBorder: true,
        subMenu: [
          {
            label: "All Payment Tickets",
            permissionKey: "pt",
            to: RoutesLink?.payment_tickets_all,
            relatedRoutes: [
              RoutesLink?.payment_tickets_all,
              `${RoutesLink?.payment_tickets_details}/againstPO/:id`,
              `${RoutesLink?.payment_tickets_details}/general/:id`,
              `${RoutesLink?.payment_tickets_details}/reimbursement/:id`,
            ],
          },
          {
            label: "Against PO",
            permissionKey: "pt",
            to: RoutesLink?.payment_ticket_against_po,
            relatedRoutes: [
              RoutesLink?.payment_ticket_against_po,
              `${RoutesLink?.payment_tickets_details}/againstPo/:id`,
              RoutesLink?.create_against_po,
            ],
          },
          {
            label: "General",
            permissionKey: "pt",
            to: RoutesLink?.payment_ticket_general,
            relatedRoutes: [
              RoutesLink?.payment_ticket_general,
              `${RoutesLink?.payment_tickets_details}/general/:id`,
              RoutesLink?.create_general,
            ],
          },
          {
            label: "Reimbursement",
            permissionKey: "pt",
            to: RoutesLink?.payment_ticket_reimbursement,
            relatedRoutes: [
              RoutesLink?.payment_ticket_reimbursement,
              `${RoutesLink?.payment_tickets_details}/reimbursement/:id`,
              RoutesLink?.create_reimbursement,
            ],
          },
        ],
      },
      {
        label: "Salary Tickets",
        permissionKey: "st",
        to: RoutesLink.salary_ticket,
        relatedRoutes: [
          RoutesLink?.create_salary_ticket,
          RoutesLink?.salary_ticket_detail,
        ],
        icon: "",
      },
      {
        label: "Office Task Management",
        permissionKey: "show",
        to: RoutesLink.task_management,
        relatedRoutes: [RoutesLink.task_management],
        icon: <OfficeTaskIcon />,
      },
      {
        label: "Site Task Management",
        permissionKey: "show",
        to: RoutesLink.site_task_management,
        icon: <SiteTaskIcon />,
        isExternal: true,
      },
      {
        label: "How to Use",
        permissionKey: "show",
        to: RoutesLink.how_to_use,
        relatedRoutes: [RoutesLink.how_to_use],
        icon: <HowToUseIcon />,
      },
    ],
  };

  const isRouteActive = (relatedRoutes = []) => {
    return relatedRoutes.some((route) => {
      if (!route) return false;
      if (route.includes("/:")) {
        const baseRoute = route.split("/:")[0];
        return location.pathname.startsWith(baseRoute);
      }
      return location.pathname === route;
    });
  };

  const toggleSidebarTab = (activeNumber) => {
    dispatch(saveSideBarScrollPosition(scrollPosition));
    if (activeSidebarTab === activeNumber) {
      dispatch(saveActiveSidebarTab(nonActiveNumber));
    } else {
      dispatch(saveActiveSidebarTab(activeNumber));
    }
  };

  useEffect(() => {
    const sidebarScroll = document.getElementById("sideWrapper");
    const handleScroll = () => {
      const scrollTop = sidebarScroll.scrollTop;
      dispatch(saveSideBarScrollPosition(scrollTop));
    };
    sidebarScroll?.addEventListener("scroll", handleScroll);

    return () => {
      sidebarScroll?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sidebarScroll = document.getElementById("sideWrapper");
    if (sidebarScroll) {
      sidebarScroll.scrollTop = scrollPosition;
    }
  }, []);

  return (
    <aside className="sidebar-wrapper">
      <div className="sidebar-content">
        <NavLink to={RoutesLink?.dashboard} className="navbar-brand ">
          <img
            className="main-logo"
            src={"/assets/img/Shreenath White Logo.png"}
            alt="main-logo"
          />
        </NavLink>
        <div className="sidebar-inner">
          <nav className="aside-nav" id="sideWrapper">
            <ul className="sidebar-vertical">
              <li>
                <NavLink
                  to={RoutesLink?.dashboard}
                  className="drop-link"
                  onClick={() => {
                    dispatch(
                      updateFiltersStates({
                        currentPage: 1,
                        pageSize: 10,
                        count: 0,
                        totalPages: 0,
                        sortByDate: [
                          moment(moment().subtract(30, "days").toDate()).format(
                            "YYYY-MM-DD",
                          ),
                          moment(moment().toDate()).format("YYYY-MM-DD"),
                        ],
                        year: getCurrentFinancialYear(),
                        companyId: "",
                        department: "",
                        designation: "",
                        requestType: "",
                        stockStatus: "",
                        vendorId: "",
                        empStatus: "current",
                        orderBy: "",
                        customerId: "",
                        customerCompanyId: "",
                        paymentStatus: "",
                      }),
                    );
                    dispatch(
                      updateDateFilter([
                        moment().startOf("month").format("YYYY-MM-DD"),
                        moment().endOf("month").format("YYYY-MM-DD"),
                      ]),
                    );
                    dispatch(saveActiveSidebarTab(nonActiveNumber));
                  }}
                >
                  <DashboardIcon />
                  <span>Dashboard</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={RoutesLink?.operations_center}
                  className="drop-link"
                  onClick={() => {
                    dispatch(saveActiveSidebarTab(nonActiveNumber));
                  }}
                >
                  <DashboardIcon />
                  <span>Operations Center</span>
                </NavLink>
              </li>
              {Object.entries(groupedMenu).map(
                ([sectionKey, items], sectionIndex) => {
                  const sectionItems = items.filter((section) => {

                    let data = userDetails?.designation?.menuBar;
                    if (typeof data === "string") {
                      try {
                        data = JSON.parse(data);
                      } catch (e) {
                        data = {};
                      }
                    }

                    if (
                      data?.keyNames?.includes(section.permissionKey) ||
                      (section?.permissionKey === "wfh" &&
                        (!data?.keyNames ||
                          data?.keyNames?.includes("wfh") ||
                          data?.keyNames?.includes("leave") ||
                          data?.keyNames?.includes("attendance"))) ||
                      section?.permissionKey === "show"
                    ) {
                      return {
                        ...items,
                      };
                    }
                  });
                  return (
                    <React.Fragment key={sectionKey}>
                      {sectionItems?.length > 0 && sectionKey !== "default" && (
                        <li key={sectionKey}>
                          <span className="menu-title border-top pt-3">
                            {sectionKey}
                          </span>
                        </li>
                      )}

                      {sectionItems?.map((menuItem, itemIndex) => {
                        const index = sectionIndex * 10 + itemIndex;
                        const subMenus = menuItem.subMenu || [];
                        const hasSubMenu = subMenus.length > 0;

                        const isMenuActive = isRouteActive(
                          menuItem.relatedRoutes,
                        );

                        if (hasSubMenu) {
                          return (
                            <React.Fragment
                              key={`${sectionKey}-${menuItem.label}`}
                            >
                              {menuItem?.isShowBorder && (
                                <li
                                  key={`${sectionKey}-${menuItem.label}-border`}
                                >
                                  <span className="menu-title border-top"></span>
                                </li>
                              )}
                              <li key={`${sectionKey}-${menuItem.label}`}>
                                <a
                                  className={`drop-link btn-menu ${activeSidebarTab === index ? "active" : ""
                                    }`}
                                  role="button"
                                  onClick={() => toggleSidebarTab(index)}
                                >
                                  {menuItem.icon}
                                  <span>{menuItem.label}</span>
                                  <ChevronArrow
                                    activeSidebarTab={activeSidebarTab}
                                    currentActiveTab={index}
                                  />
                                </a>

                                <ul
                                  className={`sub-menu1 ${activeSidebarTab === index
                                    ? "menu-open1"
                                    : "menu-close1"
                                    }`}
                                >
                                  {subMenus.map((sub, subIndex) => {
                                    const isSubActive = isRouteActive(
                                      sub.relatedRoutes,
                                    );

                                    return (
                                      <li
                                        key={`${sectionKey}-${menuItem.label}-sub-${sub.label}-${subIndex}`}
                                      >
                                        <NavLink
                                          to={sub.to}
                                          state={sub.state}
                                          className={`drop-link inner ${isSubActive ? "active" : ""
                                            }`}
                                          role="button"
                                          onClick={() => {
                                            dispatch(
                                              updateFiltersStates({
                                                currentPage: 1,
                                                paymentStatus: "",
                                                pageSize: 10,
                                                count: 0,
                                                totalPages: 0,
                                                sortByDate: [
                                                  moment(
                                                    moment()
                                                      .subtract(30, "days")
                                                      .toDate(),
                                                  ).format("YYYY-MM-DD"),
                                                  moment(
                                                    moment().toDate(),
                                                  ).format("YYYY-MM-DD"),
                                                ],
                                                year: getCurrentFinancialYear(),
                                                companyId: "",
                                                department: "",
                                                designation: "",
                                                requestType: "",
                                                stockStatus: "",
                                                vendorId: "",
                                                empStatus: "current",
                                                orderBy: "",
                                                customerId: "",
                                                customerCompanyId: "",
                                              }),
                                            );
                                            dispatch(
                                              updateDateFilter([
                                                moment()
                                                  .startOf("month")
                                                  .format("YYYY-MM-DD"),
                                                moment()
                                                  .endOf("month")
                                                  .format("YYYY-MM-DD"),
                                              ]),
                                            );
                                          }}
                                        >
                                          <span>{sub.label}</span>
                                        </NavLink>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </li>
                            </React.Fragment>
                          );
                        }

                        return (
                          <li key={`${sectionKey}-${menuItem.label}`}>
                            {menuItem.isExternal ? (
                              <a
                                href={`${menuItem.to}${Cookies.get("token") || ""}`}
                                className={`drop-link ${isMenuActive ? "active" : ""}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {menuItem.icon}
                                <span>{menuItem.label}</span>
                              </a>
                            ) : (
                              <NavLink
                                to={menuItem.to}
                                className={`drop-link ${isMenuActive ? "active" : ""
                                  }`}
                                role="button"
                                onClick={() => {
                                  dispatch(
                                    updateFiltersStates({
                                      paymentStatus: "",
                                      currentPage: 1,
                                      pageSize: 10,
                                      count: 0,
                                      totalPages: 0,
                                      sortByDate: [
                                        moment(
                                          moment().subtract(30, "days").toDate(),
                                        ).format("YYYY-MM-DD"),
                                        moment(moment().toDate()).format(
                                          "YYYY-MM-DD",
                                        ),
                                      ],
                                      year: getCurrentFinancialYear(),
                                      companyId: "",
                                      department: "",
                                      designation: "",
                                      requestType: "",
                                      stockStatus: "",
                                      vendorId: "",
                                      empStatus: "current",
                                      orderBy: "",
                                      customerId: "",
                                      customerCompanyId: "",
                                    }),
                                  );
                                  dispatch(
                                    updateDateFilter([
                                      moment()
                                        .startOf("month")
                                        .format("YYYY-MM-DD"),
                                      moment()
                                        .endOf("month")
                                        .format("YYYY-MM-DD"),
                                    ]),
                                  );
                                  dispatch(saveActiveSidebarTab(nonActiveNumber));
                                }}
                              >
                                {menuItem.icon}
                                <span>{menuItem.label}</span>
                              </NavLink>
                            )}
                          </li>
                        );
                      })}
                    </React.Fragment>
                  );
                },
              )}
              <li>
                <a
                  href={`http://oandm.shreenaths.com/?token=${Cookies.get("token") || ""}`}
                  className="drop-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DashboardIcon />
                  <span>Generation</span>
                </a>


                {/* <a
                  href={` http://localhost:5173/?token=${Cookies.get("token") || ""}`}
                  className="drop-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DashboardIcon />
                  <span>Generation</span>
                </a> */}
              </li>
              <li>
                <NavLink
                  to={RoutesLink.notifications}
                  className="drop-link "
                  role="button"
                  onClick={() => {
                    dispatch(
                      updateFiltersStates({
                        paymentStatus: "",
                        currentPage: 1,
                        pageSize: 10,
                        count: 0,
                        totalPages: 0,
                        sortByDate: [
                          moment(moment().subtract(30, "days").toDate()).format(
                            "YYYY-MM-DD",
                          ),
                          moment(moment().toDate()).format("YYYY-MM-DD"),
                        ],
                        year: getCurrentFinancialYear(),
                        companyId: "",
                        department: "",
                        designation: "",
                        requestType: "",
                        stockStatus: "",
                        vendorId: "",
                        empStatus: "current",
                        orderBy: "",
                        customerId: "",
                        customerCompanyId: "",
                      }),
                    );
                    dispatch(
                      updateDateFilter([
                        moment().startOf("month").format("YYYY-MM-DD"),
                        moment().endOf("month").format("YYYY-MM-DD"),
                      ]),
                    );
                    dispatch(saveActiveSidebarTab(nonActiveNumber));
                  }}
                >
                  <NotificationIcon />
                  <span>Notifications</span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </aside>
  );
}
